import NotificationFactory from "../notifications/notificationFactory";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import ObjectModelTriggerNotification from "~/models/objectModels/objectModelTriggerNotification";

export default class ObjectModelTriggerNotificationFactory extends NotificationFactory{
  static create(parent: ObjectModelTrigger ) {
    const notification: ObjectModelTriggerNotification = super.create(parent, ObjectModelTriggerNotification);
    notification.show_delivery_methods = false;
    return notification;
  }
}